
<div class="overlay-container" >
</div> 
<div class="modal show" id="myModal" >
 <div class="modal-dialog modal-lg">
    <div class="modal-content modal-bg">
      <!-- Modal body -->
      <div class="modal-body">
        <!-- <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
        <div id="addorUpdat" class="mt-4 mb-4">Choose Your Plate</div> -->
          
            <div class="row no-margin">
                <div class="col-12 col-sm-12 mb-3">
                    This registration is not available for renewal.  However, you have the option to change the plate style.  If you wish to do so, select <b>Continue</b> to close this message, then choose a plate style.  Otherwise. select <b>Remove</b> to remove the registration from your shopping cart.
                </div>
                  
                
              
                  
                        
                        <div class="col-12 col-sm-12 mb-3">
                            <a>
                                <button class="btn btn-primary btn-commonbtn m-auto" (click)="close()">Continue </button>
                            </a>
                     </div> 
                        <div class="col-12 col-sm-12 mb-3">
                            <a>
                                <button class="btn btn-primary btn-commonbtn m-auto"  (click)="remove()" >Remove </button>
                            </a>
                     </div>  
              </div>          
        </div>

    </div>
  </div>
</div>